import React, { createContext, useContext, useState, useEffect } from 'react';
import { apiRequest } from '../config/api';

const UserContext = createContext();

export const UserProvider = ({ children }) => {
  const [userProgress, setUserProgress] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [selectedApp, setSelectedApp] = useState(localStorage.getItem('selectedApp') || null);
  
  const fetchUserProgress = async () => {
    try {
      const data = await apiRequest('/progress');
      setUserProgress(data);
      setError(null);
    } catch (err) {
      setError(err.message);
      if (err.message === 'Authentication failed' || 
          err.message === 'Please authenticate' || 
          err.message?.includes('authentication')) {
        localStorage.removeItem('token');
        localStorage.removeItem('refreshToken');
        localStorage.removeItem('mongoToken');
        // window.location.href = '/login';
      }
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (localStorage.getItem('token')) {
      fetchUserProgress();
    } else {
      setLoading(false);
    }
  }, []);

  const updateProgress = async () => {
    await fetchUserProgress();
  };

  const selectApp = (app) => {
    if (app) {
      localStorage.setItem('selectedApp', app);
    } else {
      localStorage.removeItem('selectedApp');
    }
    setSelectedApp(app);
  };

  const value = {
    userProgress,
    loading,
    error,
    updateProgress,
    selectedApp,
    selectApp
  };

  return (
    <UserContext.Provider value={value}>
      {children}
    </UserContext.Provider>
  );
};

export const useUser = () => {
  const context = useContext(UserContext);
  if (context === undefined) {
    throw new Error('useUser must be used within a UserProvider');
  }
  return context;
}; 